import { Option } from '../../components/Form/Inputs/AutocompleteInput'
import { ProjectAcronym } from '../redux/reducers/projectsSlice'

export const filterOptions = (
  options: Option[],
  { inputValue }: { inputValue: string },
  sortedProjects: ProjectAcronym[]
) => {
  const trimmedInput = inputValue.trim()

  if (!trimmedInput) {
    return options
  }

  const lowercaseInput = trimmedInput.toLowerCase()

  const projects = sortedProjects.filter(
    project =>
      project.name.toLowerCase().includes(lowercaseInput) || project.acronym.toLowerCase().includes(lowercaseInput)
  )

  return options.filter(option => projects.some(value => value.id === option.value))
}
